<!--
 * @Author: Kuiper
 * @Date: 2021-06-25 10:26:06
-->
<template>
  <div id="app" v-if="showUi">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'App',
  setup: () => {
    const showUi = ref(false)
    onMounted(() => {
      showUi.value = false
      // const $sentry: any = inject('$sentry')
      // setTimeout(() => {
      //   $sentry && $sentry.captureException(new Error('主动抛出错误666'))
      // }, 5000)
      let query = GetUrlQueryString()
      let specifyParams = GetUrlParam('t', window.location.href)
      console.log('检测是否有固定的t=XXX参数', specifyParams)
      console.log('获取问号后面所有的参数', query)
      if (specifyParams) {
        window.location.replace('https://miitee.com/?' + query)
      } else {
        showUi.value = true
        if (_isMobile()) {
          window.location.replace('https://www.ccss.tv/#/download?' + query)
          //   window.location.replace(
          //     'https://beta-webapp.skysrt.com/sharescreen/dev/#/download?' + query
          //   )
          // window.location.replace('http://localhost:3100/sharescreen/dev/#/download?' + query)
          creatCNCC()
        }
      }
    })
    function _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
    function GetUrlQueryString() {
      var url = String(window.document.location.href)
      var allargs = url.split('?')[1]
      if (allargs) return allargs
      else return ''
    }
    //判断url中是否含有指定参数
    function GetUrlParam(name: string, url: string) {
      name = name.toLowerCase()
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var search = url || window.location.href
      search = search.substr(search.indexOf('?') + 1)
      var r = search.match(reg)
      if (r != null) return decodeURIComponent(r[2])
      else return null
    }
    //创建cnzz提交友盟
    function creatCNCC() {
      // 创建cnzz统计js
      var el: any = document.createElement('script')
      el.type = 'text/javascript'
      el.charset = 'utf-8'
      el.async = true
      let url = document.location.toString()
      let reg = RegExp(/ccss.tv/)
      el.src = 'https://v1.cnzz.com/z_stat.php?id=1279545649&web_id=1279545649&async=1'
      if (reg.test(url)) {
        el.src = 'https://v1.cnzz.com/z_stat.php?id=1279498456&web_id=1279498456&async=1'
      }
      reg = RegExp(/tvpi.coocaa.com/)
      if (reg.test(url)) {
        el.src = 'https://v1.cnzz.com/z_stat.php?id=1279498923&web_id=1279498923&async=1'
      }
      reg = RegExp(/tv.doubimeizhi.com/)
      if (reg.test(url)) {
        el.src = 'https://v1.cnzz.com/z_stat.php?id=1279545626&web_id=1279545626&async=1'
      }
      el.language = 'JavaScript'
      document.body.appendChild(el)
    }
    return {
      GetUrlQueryString,
      showUi,
    }
  },
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #e9eaeb;
}
</style>
